import { render, staticRenderFns } from "./DepartmentTreeNode.vue?vue&type=template&id=1af924e3"
import script from "./DepartmentTreeNode.vue?vue&type=script&lang=js"
export * from "./DepartmentTreeNode.vue?vue&type=script&lang=js"
import style0 from "./DepartmentTreeNode.vue?vue&type=style&index=0&id=1af924e3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports